export default __webpack_public_path__ + "static/media/Swiss Log.0139dce0.png";